import React, {Component} from 'react';
import {OrganizationChart} from 'primereact/organizationchart';



export class DepartmentCharts extends Component {

    constructor() {
        super();
        this.state = {
            data1: [{
                label: 'CEO',
                type: 'person',
                className: 'p-person',
                expanded: true,
                data: {name:'Walter White', 'avatar': 'walter.jpg'},
                children: [
                    {
                        label: 'BUSINESS DEVELOPMENT & STRATEGY',
                        type: 'person',
                        className: 'p-person',
                        expanded: true,
                        data: {name:'Saul Goodman', 'avatar': 'saul.jpg'},
                        children:[{
                            label: 'RELIABILITY',
                            className: 'department-cfo'
                        },
                        {
                            label: 'Environment, Health, Safety & Security',
                            className: 'department-cfo'
                        },
                        {
                            label: 'PLANING',
                            className: 'department-cfo'
                        }],
                    },
                    {
                        label: 'FINANCE & ADMINISTRATION',
                        type: 'person',
                        className: 'p-person',
                        expanded: true,
                        data: {name:'Mike E.', 'avatar': 'mike.jpg'},
                        children:[{
                            label: 'PROCUREMENT',
                            className: 'department-coo'
                        },
                        {
                            label: ' PROCUREMENT & CONTRACTS',
                            className: 'department-coo'
                        }]
                    
                       
                    },
                    {
                        label: 'CUSTOMER TECHNICAL SERVICE',
                        type: 'person',
                        className: 'p-person',
                        expanded: true,
                        data: {name:'Jesse Pinkman', 'avatar': 'jesse.jpg'},
                        children:[{
                            label: 'Development',
                            className: 'department-cto',
                            expanded: true,
                            children:[{
                                label: 'Analysis',
                                className: 'department-cto'
                            },
                            {
                                label: 'Front End',
                                className: 'department-cto'
                            },
                            {
                                label: 'Back End',
                                className: 'department-cto'
                            }]
                        }
                        ]
                    }
                ]
            }],
            selection: []
        };

        this.nodeTemplate = this.nodeTemplate.bind(this);
    }

    nodeTemplate(node) {
        if (node.type === "person") {
            return (
                <div>
                    <div className="node-header">{node.label}</div>
                    <div className="node-content">
                        {/* <img alt={node.data.avatar} src={`assets/demo/images/organization/${node.data.avatar}`} style={{ width: '32px' }}/> */}
                        <div>{node.data.name}</div>
                    </div>
                </div>
            );
        }

        if (node.type === "department") {
            return node.label;
        }
    }

    render() {
        return (
            <div className="p-col-12">
                <div className="card card-w-title">
                    <h1>Department Chart</h1>
                    <OrganizationChart value={this.state.data1} nodeTemplate={this.nodeTemplate} selection={this.state.selection} selectionMode="multiple"
                        onSelectionChange={event => this.setState({selection: event.data})} className="company"></OrganizationChart>
                </div>
            </div>
        )
    }
}
